import { styled } from 'styletron-react'
import { padding, margin, border } from 'lostyle'
import { Link } from 'react-router-dom'
import { media, sizes, palette, font } from '../../style'
import { H4 } from '../../components/Headings'
import { withStyle } from 'styletron-react'

export const BlogItemTitle = withStyle(H4, {
  ...padding({
    x: sizes.spacing.gutter.mobile,
    top: sizes.spacing.xs,
    bottom: sizes.spacing.gutter.mobile,
  }),
  ...media('tabletLandscape', {
    ...padding({
      x: sizes.spacing.gutter.desktop,
      top: sizes.spacing.xs,
      bottom: sizes.spacing.gutter.desktop,
    }),
  })
})
BlogItemTitle.displayName = 'Blog.Item.Title'

export const Wrapper = styled('div', (props) => ({
  width: '100%',
  ...media('tablet', {
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: '740px'
  })
}))
Wrapper.displayName = 'Blog.Wrapper'

export const BlogItemLink = styled(Link, (props) => ({
  textDecoration: 'none',
  color: 'inherit',
  borderRadius: '4px',
  background: '#fff',
  boxShadow: '0px 5px 15px rgba(0,0,0,.1)',
  display: 'block',
  ...margin(sizes.spacing.gutter.mobile),
  ...media('tabletLandscape', {
    ...margin(sizes.spacing.gutter.desktop),
  })
}))
BlogItemLink.displayName = 'Blog.Item.Link'

export const BlogItemMeta = styled('div', (props) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  ...padding({
    top: sizes.spacing.xs,
    bottom: 0,
  }),
}))
BlogItemMeta.displayName = 'Blog.Item.Meta'

export const BlogItemCategoryList = styled('span', {
  fontSize: '10px',
  fontFamily: font.system,
  color: '#aaa',
  ...border({
    width: {
      right: '3px'
    },
    style: {
      right: 'solid'
    },
    color: {
      right: palette.colors.purple
    },
  }),
  ...padding({
    top: '4px',
    right: `calc(${sizes.spacing.gutter.mobile} - 3px)`,
    bottom: '4px',
    left: 0,
  }),
  ...media('tabletLandscape', {
    ...padding({
      right: `calc(${sizes.spacing.gutter.desktop} - 3px)`,
    }),
  })
})
BlogItemCategoryList.displayName = 'Blog.Item.CategoryList'

export const BlogItemCategoryTimeStamp = styled('time', {
  fontSize: '10px',
  fontFamily: font.system,
  ...border({
    width: {
      left: '3px'
    },
    style: {
      left: 'solid'
    },
    color: {
      left: palette.colors.lightPurple
    },
  }),
  ...padding({
    top: '4px',
    left: `calc(${sizes.spacing.gutter.mobile} - 3px)`,
    bottom: '4px',
    right: 0,
  }),
  ...media('tabletLandscape', {
    ...padding({
      left: `calc(${sizes.spacing.gutter.desktop} - 3px)`,
    }),
  })
})
BlogItemCategoryTimeStamp.displayName = 'Blog.Item.TimeStamp'



// WEBPACK FOOTER //
// ./src/pages/Blog/styles.js